<div class="answer-points-section">
  <h3 class="answer-points-title">
    {{ 'simulationBuilder.KC_ANSWER_POINTS_TITLE' | transloco }}
  </h3>

  <!-- Rendered even when empty, so an answer point can be dropped into a question that has none. -->
  <qai-dragable
    [items]="answerPointItems"
    [listId]="listId()"
    [connectedTo]="connectedTo()"
    [useDragHandle]="true"
    [dragHandleDisable]="readOnly"
    (itemsChange)="onItemsReordered($event)"
    class="answer-points-list"
    [class.is-empty]="!answerPointItems.length"
  >
    <ng-template #cardTemplate let-item>
      <knowledge-check-answer-point-row
        [answerPointForm]="asFormGroup(item)"
        [answerPointIndex]="indexOf(item)"
        [readOnly]="readOnly"
        [deleting]="isDeleting(asFormGroup(item))"
        (deleteRequested)="handleDeleteRequested($event)"
        (createRetryRequested)="handleCreateRetry(asFormGroup(item))"
        [customFeedbackExpanded]="isCustomFeedbackExpanded(asFormGroup(item))"
        (customFeedbackToggled)="onCustomFeedbackToggled(asFormGroup(item))"
      />
    </ng-template>
  </qai-dragable>

  <button
    qai-button
    class="add-btn"
    [shape]="'normal'"
    [kind]="'tertiary'"
    [size]="'medium'"
    [disabled]="readOnly || !questionSaved"
    (click)="addAnswerPoint()"
  >
    <qai-icon kind="plus" size="20px" positionStart />
    <span>{{ 'simulationBuilder.KC_ADD_ANSWER_POINT' | transloco }}</span>
  </button>
</div>
